import React from "react";

interface CrossIconProps {
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  className?: string;
}

const styles = {
  closeIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
  },
  closeIconHover: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  }
}

function CrossIcon({width, height}: CrossIconProps) {
  return (
    <svg
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styles.closeIcon}
    >
      <rect
        x="11.541"
        width="2.22539"
        height="16.3195"
        rx="1.1127"
        transform="rotate(45 11.541 0)"
        fill="#323232"
      />
      <rect
        x="13.1133"
        y="11.5391"
        width="2.22539"
        height="16.3195"
        rx="1.1127"
        transform="rotate(135 13.1133 11.5391)"
        fill="#323232"
      />
    </svg>
  );
}
export default CrossIcon;